export default {
  loading: false,
  permissions: [],
  permission: {},
  totalCount: 0,
};
